var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.noAccount)?_c('div',{staticClass:"dropdown-wrapper",class:{
    mobile: _vm.isMobile,
    contextWrapped: _vm.isContextWrapped,
    'single-dropdown': _vm.isContextSelectorOfASHidden
  }},[_c('div',{staticClass:"dropdown-box-wrapper",class:{
      'single-box': _vm.noASN,
      isExpanded:
        this.selectedComboBox === _vm.selectedComboBoxType.MEMBER_ACCOUNT,
      isCollapsed: this.selectedComboBox === _vm.selectedComboBoxType.ASN_CONTEXT
    }},[_c('div',{staticClass:"dropdown-label"},[_vm._v("Member account:")]),_c('Dropdown',{attrs:{"selected":_vm.selectedAccount,"list":_vm.parsedAccountList,"placeholder":"Type member account","disabled":_vm.noAccount},on:{"on-select":_vm.onSelectAccount}})],1),(!_vm.noASN && !_vm.isContextSelectorOfASHidden)?_c('div',{staticClass:"dropdown-box-wrapper",class:{
      isExpanded: this.selectedComboBox === _vm.selectedComboBoxType.ASN_CONTEXT,
      isCollapsed:
        this.selectedComboBox === _vm.selectedComboBoxType.MEMBER_ACCOUNT
    }},[_c('div',{staticClass:"dropdown-label"},[_vm._v("Origin AS:")]),_c('Dropdown',{attrs:{"selected":_vm.selectedASN,"list":_vm.parsedASNList,"placeholder":"Type origin AS","disabled":_vm.noASN},on:{"on-select":_vm.onSelectASN}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }